import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import InputLabel from '@material-ui/core/InputLabel';

//Text fields
const useStyles = makeStyles(theme => ({
    textField: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '100%',
    },
    label: {
        marginLeft: theme.spacing(1),
    },
    doc: {
        marginRight: theme.spacing(1.5),
    },
}));

const DocumentoDS = (props) => {
    const elementos = props.componentesProps;
    const classes = useStyles();

    return (
        <>
            <InputLabel
                htmlFor="grid-doc"
                className={classes.label}
            >{props.label}</InputLabel>
            <Grid id="grid-doc" container spacing={1} className={classes.doc}>
                {
                    elementos.map((ele) => {
                        const { estado, ...other } = ele;
                        return (
                            <Grid item xs={4} key={ele.name}>
                                <TextField
                                    value={estado}
                                    {...other}
                                    className={classes.textField}
                                    onChange={props.handleChange}
                                    disabled={props.disabled}
                                    margin="normal"
                                    variant="outlined"
                                    />
                            </Grid>
                        )
                    })
                }
            </Grid>
        </>
    )
}

export default DocumentoDS;